import React, { useState } from 'react';
import { CalendarFilterFormVO } from '@domain/vo/calendar/CalendarFilterFormVO';
import DateUtil from '@utils/date/util';

const TODAY = DateUtil.getNow();

interface CalendarInfoContextInterface {
  calendarDate: Date;
  setCalendarDate: (date: Date) => void;
}

interface MiniCalendarInfoContextInterface {
  selectedDate: Date;
  startDate: string | null;
  endDate: string | null;
  setSelectedDate: (date: Date) => void;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
}

interface FilterContextInterface {
  latestFilter: CalendarFilterFormVO;
  visibleFilter: boolean;
  setLatestFilter: (filter: CalendarFilterFormVO) => void;
  setVisibleFilter: (visible: boolean) => void;
}

interface CalendarContextInterface {
  calendarInfo: CalendarInfoContextInterface;
  miniCalendarInfo: MiniCalendarInfoContextInterface;
  filter: FilterContextInterface;
}

export const CalendarContext = React.createContext<CalendarContextInterface>({
  calendarInfo: {
    calendarDate: TODAY,
    setCalendarDate: () => {
      return;
    },
  },
  miniCalendarInfo: {
    selectedDate: TODAY,
    startDate: null,
    endDate: null,
    setSelectedDate: () => {
      return;
    },
    setStartDate: () => {
      return;
    },
    setEndDate: () => {
      return;
    },
  },
  filter: {
    latestFilter: new CalendarFilterFormVO(),
    visibleFilter: false,
    setLatestFilter: () => {
      return;
    },
    setVisibleFilter: () => {
      return;
    },
  },
});

interface CalendarWrapProps {
  children: React.ReactNode;
}

const CalendarWrap = ({ children }: CalendarWrapProps) => {
  //캘린더 날짜
  const [calendarDate, setCalendarDate] = useState(TODAY);
  // 미니캘린더 선택한 날짜
  const [selectedDate, setSelectedDate] = useState<Date>(TODAY);

  // 미니캘린더 공고 시작, 끝
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  // 필터 적용된 최신 값
  const [latestFilter, setLatestFilter] = useState<CalendarFilterFormVO>(new CalendarFilterFormVO());
  // 필터 visible 값
  const [visibleFilter, setVisibleFilter] = useState(false);

  const contextData = {
    calendarInfo: {
      calendarDate,
      setCalendarDate,
    },
    miniCalendarInfo: {
      selectedDate,
      startDate,
      endDate,
      setSelectedDate,
      setStartDate,
      setEndDate,
    },
    filter: {
      latestFilter,
      visibleFilter,
      setLatestFilter,
      setVisibleFilter,
    },
  };

  return <CalendarContext.Provider value={contextData}>{children}</CalendarContext.Provider>;
};

export default CalendarWrap;
